import React from 'react'
import { useNavigate } from 'react-router-dom'
import storePersist from '../../redux/storePersist'
import { tenantDetails } from '../../request/request'

const AccountSettings = () => {
	const navigate = useNavigate()

    const handleLogout = () => {
		localStorage.removeItem('token')
		localStorage.removeItem('accessTokenMetadata')
		localStorage.removeItem('guestTokenMetadata')
		localStorage.removeItem('userProfile')
        const specificChannel = storePersist?.get("channels")?.current.find(
            (element:any) => element.SalesChannelName === "Portal"
          );
          tenantDetails.SalesChannelName = "Platform";
          tenantDetails.StoreId = specificChannel?.StoreId;
          tenantDetails.SalesChannelId = specificChannel?.Id;
		navigate('/')
	}
  return (
    <div className="w-1/4 mt-20 justity-center items-center">
    <li onClick={() => navigate('/dbn/profile')}
        className="flex flex-row items-start justify-center space-y-1 px-10 mx-10 py-3">
        <svg fill="#FFB934" className="w-6 h-6" viewBox="0 0 24 24" data-name="Layer 1" id="Layer_1">
            <title />
            <path d="M22,11V7.83L12,2.06,2,7.83V11H4v8H2v2H22V19H20V11ZM4,9l8-4.62L20,9H4ZM6,19V11H8v8Zm4,0V11h4v8Zm8,0H16V11h2Z" />
        </svg>
        <a className=" hover:text-[#FFB934] uppercase text-xs px-2">
            Account
        </a>
    </li>
    <li
        onClick={() => navigate('/dbn/address')}
        className=" flex flex-row items-start justify-center space-y-1 px-10 mx-10 py-3">
        <svg className="w-6 h-6" fill="#FFB934" viewBox="0 0 24 24" ><path d="M4 4H3v1h2V2h1v20H5v-1H4v2h18V1H4zm3-2h14v20H7zM5 20H3v-1h1v-1h1zm0-6H3v-1h1v-1h1zm0-6H3V7h1V6h1zm0 3H3v-1h1V9h1zm0 6H3v-1h1v-1h1zm10.5-5h-3A3.504 3.504 0 0 0 9 15.5V18h10v-2.5a3.504 3.504 0 0 0-3.5-3.5zm2.5 5h-8v-1.5a2.503 2.503 0 0 1 2.5-2.5h3a2.503 2.503 0 0 1 2.5 2.5zm-4-6a3 3 0 1 0-3-3 3.003 3.003 0 0 0 3 3zm0-5a2 2 0 1 1-2 2 2.002 2.002 0 0 1 2-2z" /><path fill="none" d="M0 0h24v24H0z" /></svg>								<a className=" hover:text-[#FFB934] uppercase text-xs" href="#">
        <a className=" hover:text-[#FFB934] uppercase text-xs px-2">
            Address
        </a>
        </a>
    </li>
    <li
        onClick={() => navigate('/dbn/helpcenter')}
        className=" flex flex-row items-start justify-center space-y-1 px-10 mx-10 py-3">
        <svg className="w-6 h-6" fill="#FFB934" viewBox="0 0 256 256"><path d="M201.89,54.66A103.43,103.43,0,0,0,128.79,24H128A104,104,0,0,0,24,128v56a24,24,0,0,0,24,24H64a24,24,0,0,0,24-24V144a24,24,0,0,0-24-24H40.36A88.12,88.12,0,0,1,190.54,65.93,87.39,87.39,0,0,1,215.65,120H192a24,24,0,0,0-24,24v40a24,24,0,0,0,24,24h24a24,24,0,0,1-24,24H136a8,8,0,0,0,0,16h56a40,40,0,0,0,40-40V128A103.41,103.41,0,0,0,201.89,54.66ZM64,136a8,8,0,0,1,8,8v40a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V136Zm128,56a8,8,0,0,1-8-8V144a8,8,0,0,1,8-8h24v56Z"></path></svg>
        <a className=" hover:text-[#FFB934] uppercase text-xs px-2" >
            HelpCenter
        </a>
    </li>
    <li className=" flex flex-row items-start justify-center space-y-1 px-10 mx-10 py-3" >
        <svg fill="#FFB934" className="h-6 w-6" version="1.1" id="Capa_1" viewBox="0 0 384.971 384.971">
            <path d="M180.455,360.91H24.061V24.061h156.394c6.641,0,12.03-5.39,12.03-12.03s-5.39-12.03-12.03-12.03H12.03
C5.39,0.001,0,5.39,0,12.031V372.94c0,6.641,5.39,12.03,12.03,12.03h168.424c6.641,0,12.03-5.39,12.03-12.03
C192.485,366.299,187.095,360.91,180.455,360.91z"/>
            <path d="M381.481,184.088l-83.009-84.2c-4.704-4.752-12.319-4.74-17.011,0c-4.704,4.74-4.704,12.439,0,17.179l62.558,63.46H96.279
c-6.641,0-12.03,5.438-12.03,12.151c0,6.713,5.39,12.151,12.03,12.151h247.74l-62.558,63.46c-4.704,4.752-4.704,12.439,0,17.179
c4.704,4.752,12.319,4.752,17.011,0l82.997-84.2C386.113,196.588,386.161,188.756,381.481,184.088z"/>
        </svg>								<a className=" hover:text-[#FFB934] uppercase text-xs px-2" onClick={() => handleLogout()}>Logout</a>
    </li>
</div>
  )
}

export default AccountSettings